import React from "react";
import PropTypes from "prop-types";
//Styles
import styled from "styled-components";
import theme from "../../../styles/theme.semantic";

const PlusButton = ({
  onClick,
  href,
  size,
  backgroundColor,
  borderRight,
  borderTop,
  borderBottom,
  cursor,
  target,
  alt,
  as,
  ...props
}) => {
  return (
    <Wrapper tabIndex={-1} {...props} onClick={onClick}>
      <Triangle
        as={as}
        alt={alt}
        target={target}
        tabIndex={0}
        size={size}
        backgroundColor={backgroundColor}
        borderRight={borderRight}
        borderTop={borderTop}
        borderBottom={borderBottom}
        cursor={cursor}
        {...props}
      >
        {props.children}
      </Triangle>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin-left: ${props => props.marginLeft};
  width: ${props => props.size};
  height: ${props => props.height};
  display: flex;
  align-items: ${props => props.alignItems};
  justify-content: ${props => props.justifyContent};
  z-index: ${props => props.zIndex};
  position: ${props => props.position};
  top: ${props => props.top};
  right: ${props => props.right};
  bottom: ${props => props.bottom};
  left: ${props => props.left};
  width: ${props => props.width};
  // Extra small devices (portrait phones, less than 576px)
  @media (max-width: 575px) {
    width: ${props => props.XsSize};
  }
`;

const Triangle = styled.span`
  text-decoration: none;
  width: ${props => props.size};
  height: ${props => props.size};
  background-color: ${props => props.backgroundColor};
  transform: rotate(45deg);
  display: flex;
  align-items: center;
  border-right: ${props => props.borderRight};
  border-top: ${props => props.borderTop};
  border-bottom: ${props => props.borderBottom};
  border-left: ${props => props.borderLeft};
  cursor: ${props => props.cursor || "pointer"};
  i,
  p {
    margin: auto;
    font-size: ${props => props.fontSize};
    transform: rotate(-45deg);
  }
`;

PlusButton.propTypes = {
  marginLeft: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  alignItems: PropTypes.string,
  zIndex: PropTypes.string,
  position: PropTypes.string,
  top: PropTypes.string,
  right: PropTypes.string,
  bottom: PropTypes.string,
  left: PropTypes.string,
  backgroundColor: PropTypes.string,
  borderBottom: PropTypes.string,
  borderRight: PropTypes.string,
  fontSize: PropTypes.string,
  children: PropTypes.node,
  href: PropTypes.string
};

PlusButton.defaultProps = {
  alignItems: "center",
  position: "absolute",
  backgroundColor: theme.components.plusButton.backgroundColor,
  borderBottom: "none",
  borderRight: "none",
  children: null,
  href: null
};

export default PlusButton;
